<template>
  <div class="login-van-popup">
    <van-popup
      v-model="show"
      closeable
      close-icon-position="top-right"
      position="bottom"
      @closed="close"
      close-icon="https://iqh-zt-pord-cdn.iqihang.com/ark-question-bank/closeIcon.png"
      :style="{width:'100%',height:'400px',zIndex:10002}"
    >
      <MobileLogin @changeType="changeType" v-if="type === 'mobile'"/>
      <PassWordLogin @loginSuccess="loginSuccess" @changeType="changeType" v-else-if="type === 'password'"/>
      <GetCode @loginCallBack="loginSuccess" @changeType="changeType" v-else-if="type === 'code'"/>
    </van-popup>
  </div>
</template>

<script>
import MobileLogin from './registrationLogin'
import PassWordLogin from './passwordLogin'
import GetCode from './getCode'

export default {
  name: 'login',
  props: ['visible', 'loginCallBack'],
  data() {
    return {
      //show:true,
      show: this.visible,
      type: 'mobile' // mobile/password/code
    };
  },
  components: {
    MobileLogin,
    PassWordLogin,
    GetCode
  },
  computed: {},
  watch: {
    visible(value) {
      this.show = value
    }
  },
  methods: {
    loginSuccess(user) {
      this.$emit('loginCallBack', user)
    },
    callBack() {

    },
    changeType(type) {
      this.type = type
    },
    reset() {
      this.type = 'mobile'
    },
    close() {
      this.reset()
      this.$emit('loginClose')
    }
  },
  created() {
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>

</style>
<style lang="scss">
.login-van-popup {
  .van-overlay{
    z-index: 10003!important;
  }
  .van-popup.van-popup--bottom{
    z-index: 10004!important;
  }
  .van-icon.van-popup__close-icon.van-popup__close-icon--top-right{
    width: 16px;
    img{
      width: 100%;
    }
  }
}
</style>
